import React, { useState, useEffect } from "react";
import styles from "../styles/Autocomplete.module.scss";
import {
  Highlight,
  connectAutoComplete,
  HitsPerPage
} from "react-instantsearch-dom";
import { Input } from "reactstrap";

const Autocomplete = ({
  hits,
  currentRefinement,
  refine,
  inputPlaceholder,
  onChangeQuery,
  clearSearch,
  inputClassName,
  handleOnBlur,
  openToggle,
  handleSearch
}) => {
  const [focus, setFocus] = useState(false);
  const [query, setQuery] = useState("");
  // console.log({ hits, currentRefinement });

  //   const onSuggestionsClearRequested = () => (hits = []);

  const onChangeKeyword = query => {
    setQuery(query);
    // Sending Search keyword to parent
    onChangeQuery(query);
  };

  const onSuggestionSelected = query => {
    openToggle && openToggle();
    setFocus(false);
    setQuery(query);
    handleSearch && handleSearch(query);
    onChangeQuery(query);
  };

  const onClearSuggestions = () => {
    setQuery("");
    currentRefinement = null;
  };

  const onBlurHandler = () => {
    setTimeout(() => {
      setFocus(false);
      handleOnBlur && handleOnBlur();
    }, 100);
  };
  useEffect(() => {
    clearSearch && onClearSuggestions();
  }, [clearSearch]);

  if (clearSearch && currentRefinement) currentRefinement = "";
  // console.log({ query, clearSearch, currentRefinement });
  return (
    <>
      <Input
        type="search"
        placeholder={inputPlaceholder || ""}
        value={query || currentRefinement}
        onChange={event => {
          refine(event.currentTarget.value);
          onChangeKeyword(event.target.value);
        }}
        onFocus={() => setFocus(true)}
        style={{ borderRadius: "0px" }}
        onBlur={() => onBlurHandler()}
      />
      {focus && query && hits.length > 0 && (
        <>
          <hr style={{ color: "#efefef" }} />
          <ul className={styles.autocomplete_hints}>
            {hits.map(hit => (
              <li
                key={hit.objectID}
                className={styles.autocomplete_hints_hint}
                onClick={() => onSuggestionSelected(hit.title)}
              >
                {" "}
                <Highlight
                  attribute="company.name"
                  attribute="title"
                  hit={hit}
                  tagName="mark"
                />{" "}
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );
};

export default connectAutoComplete(Autocomplete);
